/**
 * ChartRegion: `ChartFrame` for a chart you can step through with the keyboard (DESIGN-RESULTS §2): the same aria summary and "View as table", and the chart region itself takes focus
 * (`role="img"`, `tabIndex=0`) and hands arrow keys to the chart. Kept beside the charts so `theme/ChartFrame` stays as it is.
 */
import { useState, type KeyboardEvent, type ReactNode } from "react";
import { ChartTableView, useChartTables, type ChartTable } from "../theme/ChartFrame";

export function ChartRegion({ summary, table, children, onKey, onLeave }: { readonly summary: string; readonly table: ChartTable; readonly children: ReactNode; readonly onKey: (e: KeyboardEvent<HTMLDivElement>) => void; readonly onLeave: () => void }) {
  const [own, setOwn] = useState(false);
  const shared = useChartTables();
  const asTable = shared ?? own;
  return (
    <div className="gx-chartframe">
      {asTable ? (
        <ChartTableView table={table} />
      ) : (
        <div role="img" aria-label={summary} tabIndex={0} className="gx-chart-focus" onKeyDown={onKey} onBlur={onLeave}>{children}</div>
      )}
      {shared === null ? (
        <button type="button" className="gx-btn gx-btn--secondary gx-small gx-chart-toggle" aria-pressed={asTable} onClick={() => setOwn((v) => !v)}>
          {asTable ? "View as chart" : "View as table"}
        </button>
      ) : null}
    </div>
  );
}
